var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpinner44(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 44a1.5 1.5 0 010-3c10.493 0 19-8.507 19-19S32.493 3 22 3 3 11.507 3 22c0 2.208.376 4.363 1.103 6.397a1.5 1.5 0 11-2.825 1.01A21.964 21.964 0 010 22C0 9.85 9.85 0 22 0s22 9.85 22 22-9.85 22-22 22z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMjIgNDRhMS41IDEuNSAwIDAgMSAwLTNjMTAuNDkzIDAgMTktOC41MDcgMTktMTlTMzIuNDkzIDMgMjIgMyAzIDExLjUwNyAzIDIyYzAgMi4yMDguMzc2IDQuMzYzIDEuMTAzIDYuMzk3YTEuNSAxLjUgMCAxIDEtMi44MjUgMS4wMUEyMS45NjQgMjEuOTY0IDAgMCAxIDAgMjJDMCA5Ljg1IDkuODUgMCAyMiAwczIyIDkuODUgMjIgMjItOS44NSAyMi0yMiAyMloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgSpinner44 as ReactComponent };